import React from 'react';
import { womenCalculators_En } from '../ConstantsEN';
import SharedHelmet from '../Helmet';
const TITLE = 'Women Calculators - Free Calculators for Women’s Health, Pregnancy, and Menstrual Cycle';
const DESCRIPTION = 'Explore our collection of free womens health calculators, including menstrual cycle calculators, pregnancy calculators, and important dates in women’s health.';
const KEYWORDS = 'Women calculators, free calculators, menstrual cycle calculator, pregnancy calculator, women’s health dates';
const OG_URL = 'https://do-calculate.com/en/women-calculators';
function CalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >Calculator</th>
                        <th >Description</th>
                    </tr>
                </thead>
                <tbody>
                    {womenCalculators_En.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
